// 14 fiches métiers (iter 21) — chacune avec son SEO unique : H1, 3-4 risques,
// exemples sectoriels, mots-clés. Aucun prix affiché — uniquement
// "Devis personnalisé en − de 24h".

export const METIERS = {
  "artisan-batiment": {
    slug: "artisan-batiment",
    label: "Artisan du bâtiment",
    overline: "Bâtiment · Artisanat",
    h1: "Assurance Artisan du bâtiment.",
    intro:
      "Maçon, charpentier, plombier, peintre, plaquiste, carreleur : votre activité expose votre entreprise à des risques spécifiques sur chaque chantier. Je négocie une couverture sur mesure incluant la garantie décennale obligatoire.",
    examples:
      "Exemple : Un artisan plombier intervenant chez un particulier endommage involontairement une canalisation collective. La RC pro et la décennale prennent en charge les conséquences.",
    risks: [
      "Garantie décennale obligatoire — protection 10 ans après réception des travaux",
      "Responsabilité civile professionnelle et exploitation",
      "Multirisque outillage, matériel et engins de chantier",
      "Garantie biennale et de parfait achèvement",
    ],
    seoTitle: "Assurance Artisan du bâtiment · Décennale & RC Pro | OPTINA",
    seoDescription:
      "Courtier indépendant pour artisans du bâtiment : décennale, RC professionnelle, multirisque chantier. Devis personnalisé en − de 24h.",
    icon: "HardHat",
  },
  coach: {
    slug: "coach",
    label: "Coach",
    overline: "Coaching · Accompagnement",
    h1: "Assurance Coach.",
    intro:
      "Coach professionnel, coach de vie, coach sportif, coach mental ou bien-être : votre activité d'accompagnement individuel demande une RC pro adaptée à votre cadre d'intervention.",
    examples:
      "Exemple : Un coaché conteste votre méthodologie après une session. La RC pro couvre les éventuels frais de défense et indemnités.",
    risks: [
      "RC pro coaching et accompagnement",
      "Multirisque local ou salle (si applicable)",
      "Protection juridique et défense recours",
      "Prévoyance — maintien de revenus",
    ],
    seoTitle: "Assurance Coach · RC Pro | OPTINA",
    seoDescription:
      "Assurance pro pour coachs de vie, coachs sportifs, coachs mentaux. RC pro adaptée. Devis personnalisé en − de 24h.",
    icon: "Dumbbell",
  },
  coiffeur: {
    slug: "coiffeur",
    label: "Coiffeur",
    overline: "Coiffure · Esthétique",
    h1: "Assurance Coiffeur.",
    intro:
      "Salon de coiffure, barbier, coiffeur à domicile : votre métier de proximité demande une protection complète du salon, du matériel et de votre responsabilité envers vos clients.",
    examples:
      "Exemple : Une cliente subit une réaction allergique à une teinture malgré le test préalable. La RC pro couvre les éventuels dommages corporels.",
    risks: [
      "Responsabilité civile professionnelle — fautes, blessures, allergies",
      "Multirisque salon : local, mobilier, fonds de commerce, miroirs, vol",
      "Perte d'exploitation en cas de sinistre fermant le salon",
      "Protection juridique et défense en cas de litige client",
    ],
    seoTitle: "Assurance Coiffeur · Salon & domicile | OPTINA",
    seoDescription:
      "Assurance professionnelle coiffeur : RC pro, multirisque salon, perte d'exploitation. Courtier indépendant — devis en − de 24h.",
    icon: "Scissors",
  },
  commercant: {
    slug: "commercant",
    label: "Commerçant",
    overline: "Commerce de détail",
    h1: "Assurance Commerçant.",
    intro:
      "Boutique de prêt-à-porter, épicerie fine, librairie, fleuriste : protégez votre commerce, vos marchandises et votre chiffre d'affaires face aux risques quotidiens.",
    examples:
      "Exemple : Un dégât des eaux ravage votre stock saisonnier. La multirisque commerce + la perte d'exploitation prennent le relais.",
    risks: [
      "Multirisque commerce : local, marchandises, stocks, vitrines, bris de glace",
      "Responsabilité civile exploitation et professionnelle",
      "Perte d'exploitation et frais supplémentaires en cas de fermeture",
      "Garantie vol, vandalisme, cyber-rançon",
    ],
    seoTitle: "Assurance Commerçant · Multirisque & RC Pro | OPTINA",
    seoDescription:
      "Assurance multirisque commerce et RC pro pour commerçants. Courtier indépendant, devis personnalisé en − de 24h.",
    icon: "Store",
  },
  consultant: {
    slug: "consultant",
    label: "Consultant",
    overline: "Conseil · Expertise",
    h1: "Assurance Consultant.",
    intro:
      "Consultant indépendant, freelance, coach d'entreprise, formateur : votre activité intellectuelle expose à des recours pour mauvais conseil. La RC pro est votre filet de sécurité indispensable.",
    examples:
      "Exemple : Un client estime que votre recommandation stratégique lui a fait perdre un marché. La RC pro couvre les frais de défense et les dommages-intérêts éventuels.",
    risks: [
      "Responsabilité civile professionnelle — fautes, erreurs et omissions de conseil",
      "Protection juridique et défense pénale",
      "Multirisque bureau et matériel informatique",
      "Cyber-risques et perte de données clients",
    ],
    seoTitle: "Assurance Consultant indépendant · RC Pro & Cyber | OPTINA",
    seoDescription:
      "RC pro consultant, freelance, formateur : couverture des erreurs de conseil et cyber-risques. Courtier indépendant.",
    icon: "Briefcase",
  },
  electricien: {
    slug: "electricien",
    label: "Électricien",
    overline: "Électricité · Domotique",
    h1: "Assurance Électricien.",
    intro:
      "Électricien général, courant fort/faible, domotique, IRVE : votre métier présente un risque incendie et un risque humain élevé. Décennale et RC pro sont obligatoires.",
    examples:
      "Exemple : Un défaut d'installation provoque un court-circuit déclenchant un incendie chez le client. La décennale couvre les réparations sur 10 ans.",
    risks: [
      "Garantie décennale électricité obligatoire",
      "RC professionnelle — accidents corporels et matériels",
      "Multirisque outillage et matériel embarqué (camionnette)",
      "Protection juridique et défense recours",
    ],
    seoTitle: "Assurance Électricien · Décennale & RC Pro | OPTINA",
    seoDescription:
      "Décennale électricien, RC pro, multirisque outillage. Courtier indépendant — devis en − de 24h.",
    icon: "Zap",
  },
  hotellerie: {
    slug: "hotellerie",
    label: "Hôtellerie",
    overline: "Hôtels · Gîtes · Chambres d'hôtes",
    h1: "Assurance Hôtellerie.",
    intro:
      "Hôtel indépendant, gîte, chambres d'hôtes, résidence de tourisme : votre activité d'accueil cumule risques liés au bâti, à la clientèle et à l'exploitation.",
    examples:
      "Exemple : Un client se blesse dans votre établissement. La RC pro et la multirisque hôtellerie prennent en charge l'incident.",
    risks: [
      "Multirisque hôtellerie — bâtiment, mobilier, équipements",
      "Responsabilité civile exploitation et hôtelière",
      "Perte d'exploitation en cas de fermeture",
      "Garantie objets confiés et bagages clients",
    ],
    seoTitle: "Assurance Hôtellerie · Multirisque hôtelière | OPTINA",
    seoDescription:
      "Assurance hôtels, gîtes, chambres d'hôtes : multirisque, RC, perte d'exploitation. Courtier indépendant.",
    icon: "UtensilsCrossed",
  },
  informatique: {
    slug: "informatique",
    label: "Informatique",
    overline: "IT · Développeur · SSII",
    h1: "Assurance Métier Informatique.",
    intro:
      "Développeur, intégrateur, prestataire IT, SSII, agence digitale : votre activité expose à des recours pour bug, perte de données ou cyber-incident. La RC pro IT est indispensable.",
    examples:
      "Exemple : Un bug critique en production stoppe l'activité de votre client. La RC pro IT couvre les préjudices financiers.",
    risks: [
      "RC pro informatique — bugs, défauts, retards",
      "Cyber-risques et atteinte aux données",
      "Multirisque matériel et serveurs",
      "Protection juridique et défense recours",
    ],
    seoTitle: "Assurance Informatique · RC Pro IT & Cyber | OPTINA",
    seoDescription:
      "RC pro informatique pour développeurs, SSII, agences digitales. Couverture cyber et bugs critiques.",
    icon: "Briefcase",
  },
  photographe: {
    slug: "photographe",
    label: "Photographe",
    overline: "Photographie · Vidéo",
    h1: "Assurance Photographe.",
    intro:
      "Photographe de mariage, portrait, événementiel, studio, photographe drone : votre matériel coûteux et vos prestations clients exigent une protection adaptée.",
    examples:
      "Exemple : Votre appareil photo tombe lors d'un reportage. La garantie matériel et la RC pro vous protègent intégralement.",
    risks: [
      "Multirisque matériel photo et vidéo (vol, casse, transport)",
      "RC pro photographe — droit à l'image et prestations",
      "Garantie perte de données et fichiers",
      "Protection juridique et défense recours",
    ],
    seoTitle: "Assurance Photographe · Matériel & RC Pro | OPTINA",
    seoDescription:
      "Assurance photographe pro : matériel, RC pro, droit à l'image, perte de fichiers. Devis personnalisé.",
    icon: "Briefcase",
  },
  psychologue: {
    slug: "psychologue",
    label: "Psychologue",
    overline: "Psychologie · Thérapie",
    h1: "Assurance Psychologue.",
    intro:
      "Psychologue clinicien, psychothérapeute, psychopraticien, neuropsychologue : votre métier d'accompagnement psychique exige une RC pro renforcée et adaptée à la profession réglementée.",
    examples:
      "Exemple : Un patient invoque un préjudice après une thérapie. La RC pro psychologue prend en charge la défense et les éventuels dommages.",
    risks: [
      "RC pro psychologue / psychothérapeute renforcée",
      "Multirisque cabinet et matériel",
      "Protection juridique professionnelle",
      "Prévoyance — maintien de revenus",
    ],
    seoTitle: "Assurance Psychologue · RC Pro | OPTINA",
    seoDescription:
      "RC pro psychologue, psychothérapeute, psychopraticien. Courtier indépendant — devis personnalisé.",
    icon: "Scale",
  },
  restaurateur: {
    slug: "restaurateur",
    label: "Restaurateur",
    overline: "Restaurants · Brasseries",
    h1: "Assurance Restaurateur.",
    intro:
      "Restaurant gastronomique, brasserie, pizzeria, traiteur, food truck : votre activité cumule risques alimentaires, accueil du public et perte d'exploitation.",
    examples:
      "Exemple : Une intoxication collective survient après un service. La garantie intoxication alimentaire + RC pro prennent en charge les frais et indemnités.",
    risks: [
      "Multirisque restaurant — local, matériel de cuisine, stocks",
      "Garantie intoxication alimentaire et empoisonnement",
      "Perte d'exploitation en cas de fermeture administrative",
      "RC exploitation, vol, bris de glace, incendie",
    ],
    seoTitle: "Assurance Restaurateur · Multirisque CHR | OPTINA",
    seoDescription:
      "Assurance restaurateur : multirisque, perte d'exploitation, intoxication alimentaire. Courtier indépendant.",
    icon: "UtensilsCrossed",
  },
  securite: {
    slug: "securite",
    label: "Sécurité",
    overline: "Agent de sécurité · Gardiennage",
    h1: "Assurance Métier Sécurité.",
    intro:
      "Agent de sécurité, société de gardiennage, sécurité événementielle, agent cynophile : votre métier de protection physique expose à une responsabilité accrue.",
    examples:
      "Exemple : Un incident survient lors d'une intervention. La RC pro sécurité couvre les frais de défense et indemnités éventuelles.",
    risks: [
      "RC pro sécurité renforcée (CNAPS)",
      "Multirisque local, matériel et véhicules d'intervention",
      "Protection juridique et défense pénale",
      "Garantie agents cynophiles si applicable",
    ],
    seoTitle: "Assurance Sécurité · Agent & gardiennage | OPTINA",
    seoDescription:
      "RC pro pour agents de sécurité, sociétés de gardiennage, sécurité événementielle. Courtier indépendant.",
    icon: "Scale",
  },
  tatoueur: {
    slug: "tatoueur",
    label: "Tatoueur",
    overline: "Tatouage · Perçage",
    h1: "Assurance Tatoueur.",
    intro:
      "Tatoueur professionnel, pierceur, studio de tatouage : votre métier au contact direct de la peau expose à des risques sanitaires et de responsabilité spécifiques.",
    examples:
      "Exemple : Un client développe une infection après un tatouage malgré vos protocoles. La RC pro tatoueur prend en charge la défense.",
    risks: [
      "RC pro tatoueur / pierceur — risques sanitaires",
      "Multirisque studio : local, matériel, instruments stériles",
      "Garantie hygiène et conformité ARS",
      "Protection juridique professionnelle",
    ],
    seoTitle: "Assurance Tatoueur · RC Pro spécialisée | OPTINA",
    seoDescription:
      "RC pro tatoueur, pierceur, studio. Couverture sanitaire et juridique. Courtier indépendant.",
    icon: "Scissors",
  },
  "taxi-vtc": {
    slug: "taxi-vtc",
    label: "Taxi & VTC",
    overline: "Transport de personnes",
    h1: "Assurance Taxi & VTC.",
    intro:
      "Chauffeur VTC, taxi, transport médico-social : votre véhicule est votre outil de travail. Je négocie une assurance flotte ou véhicule professionnel adaptée à votre kilométrage et à votre métier.",
    examples:
      "Exemple : Un accident en service immobilise votre véhicule. Le véhicule de remplacement et la perte d'exploitation couvrent vos pertes de revenus.",
    risks: [
      "Assurance auto pro Taxi / VTC",
      "RC transporteur de personnes",
      "Véhicule de remplacement et perte d'exploitation",
      "Protection juridique et défense conducteur",
    ],
    seoTitle: "Assurance Taxi & VTC · Flotte | OPTINA",
    seoDescription:
      "Assurance VTC, taxi, transport médico-social : véhicule pro, RC, perte d'exploitation. Devis personnalisé.",
    icon: "Car",
  },
};

export const METIERS_LIST = Object.values(METIERS);
